import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import { Button, Grid } from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import { ValidatorForm } from "react-material-ui-form-validator";
import { useForm } from "../../../../hooks/useForm";
import { validarSoloUnPermiso } from "../../../../helpers/permisos";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import esLocale from "date-fns/locale/es";
import DateFnsUtils from "@date-io/date-fns";
import moment from "moment";
import ValidatedDatePicker from "../../../compartidos/ValidatedDatePicker";

const useStyles = makeStyles({
    botonera: {
        padding: 25,
        marginTop: 25
    }
});

export const FormRecupero = (props) => {
    const classes = useStyles();
    const { formData, permisoEdit, permisoAlta } = props;
    const { permisos: permisosUser } =  useSelector(state => state.auth);
    

    const formInit = {
      fechaInicio: new Date()
    }

    const [formValues, , , setearValor] = useForm(formData ? formData : formInit);

    const handleSave = (e) => {
        e.preventDefault()
        props.handleSave(formValues);
    };

    return (
      <ValidatorForm onSubmit={handleSave}>
        <Grid container style={{ padding: 25 }} justify="center">
          <Grid item xs={12} sm={4}>
            <MuiPickersUtilsProvider
              locale={esLocale}
              utils={DateFnsUtils}
            >
              <ValidatedDatePicker
                margin="normal"
                style={{minWidth: 145}}
                id="dialogFechaInicio"
                format="dd/MM/yyyy"
                okLabel="Aceptar"
                name="fechaInicio"
                label="Fecha Inicio"
                clearLabel="Limpiar"
                cancelLabel="Cancelar"
                maxDate={formValues.fechaFin}
                value={
                  moment(formValues.fechaInicio).isValid()
                    ? moment(formValues.fechaInicio)
                    : null
                }
                onChange={(date) => {
                  setearValor("fechaInicio", date);
                }}
                KeyboardButtonProps={{
                    "aria-label": "change date",
                }}
                validators={["required"]}
                errorMessages={["La fecha es requerida"]}
              />
            </MuiPickersUtilsProvider>            
          </Grid>
          <Grid item xs={12} sm={4}>
            <MuiPickersUtilsProvider
              locale={esLocale}
              utils={DateFnsUtils}
            >
              <ValidatedDatePicker
                margin="normal"
                style={{minWidth: 145}}
                id="dialogFechaFin"
                format="dd/MM/yyyy"
                okLabel="Aceptar"
                name="fechaFin"
                label="Fecha Fin"
                clearLabel="Limpiar"
                cancelLabel="Cancelar"
                minDate={formValues.fechaInicio}
                value={
                  moment(formValues.fechaFin).isValid()
                    ? moment(formValues.fechaFin)
                    : null
                }
                onChange={(date) => {
                  setearValor("fechaFin", date);
                }}
                KeyboardButtonProps={{
                    "aria-label": "change date",
                }}
              />
            </MuiPickersUtilsProvider>            
          </Grid>

          <Grid container className={classes.botonera}>
            <Grid item xs={12}>
              <Grid
                container
                spacing={1}
                direction="row"
                justify="space-between"
                alignItems="center"
              >    
                
                <Button
                  variant="contained"
                  color="secondary"
                  size="small"
                  startIcon={<CancelIcon />}
                  onClick={props.cerrarModal}
                >
                  CANCELAR
                </Button>
                {(validarSoloUnPermiso(permisosUser, permisoAlta) ||
                  validarSoloUnPermiso(permisosUser, permisoEdit)) && (
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    startIcon={<SaveIcon />}
                    type="submit"
                    style={{ marginLeft: "0.5rem" }}
                  >
                    GUARDAR
                  </Button>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </ValidatorForm>
    );
};
export default FormRecupero;